<ion-card class="ion-no-margin"  *ngIf="user.profile">
  <ion-card-header class="ion-text-center">
    <ng-container *ngIf="user.profile.profile_picture; else defaultIcon">
      <img [src]="user.profile.profile_picture" alt="">
    </ng-container>
    <ng-template #defaultIcon>
      <ion-icon class="cus-large" name="person-circle-outline"></ion-icon>
    </ng-template>
  </ion-card-header>
  <ion-card-content class="ion-text-center">
    <div class="group-container">
      <ion-item lines="none">
        <ion-label>
          <p>First Name</p>
          <h2>{{ user.profile.name }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Last Name</p>
          <h2>{{ user.profile.surname }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Position</p>
          <h2>{{ user.profile.position }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Birthday</p>
          <h2>{{ user.profile.birthday }}</h2>
        </ion-label>
      </ion-item>
    </div>

    <div class="group-container">
      <ion-item lines="none">
        <ion-label>
          <p>Business Email</p>
          <h2>{{ user.email }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none" *ngIf="$edit | async">
        <ion-label>
          <p>Business Phone</p>
          <h2>{{ user.profile.phone }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Office</p>
          <h2>{{ user.profile.business_unit }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label><p>LinkedIn</p></ion-label>
        <a target="_blank" href="{{user.profile.linkedIn}}"> <ion-icon color="primary" name="open-outline"></ion-icon></a>
      </ion-item>
    </div>

    <div class="group-container">
      <ion-item lines="none">
        <ion-label>
          <p>Work Allocation</p>
          <h2>{{ employment?.position }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Percentage</p>
          <h2>{{ employment?.percentage }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Weekly Hours</p>
          <h2>{{ employment?.weekly_hours }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Start Date</p>
          <h2>{{ employment?.start_date }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Employment Country</p>
          <h2>{{ user.profile.employment_country }}</h2>
        </ion-label>
      </ion-item>
    </div>

    <div class="group-container">
      <ion-item lines="none">
        <ion-label>
          <p>IBAN</p>
          <h2>{{ employment?.iban }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Street</p>
          <h2>{{ user.address?.street }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Number</p>
          <h2>{{ user.address?.number }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>ZIP</p>
          <h2>{{ user.address?.zip_code }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>City</p>
          <h2>{{ user.address?.city }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Country</p>
          <h2>{{ user.address?.country }}</h2>
        </ion-label>
      </ion-item>
    </div>

    <div class="group-container">
      <ion-item lines="none">
        <ion-label>
          <p>Manager</p>
          <h2>{{ user.profile.manager?.email }}</h2>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label>
          <p>Managees</p>
          <h2>{{ getManagees() }}</h2>
        </ion-label>
      </ion-item>
    </div>

    <ion-button *ngIf="$edit | async" expand="block" (click)="edit()" data-testid="employment-users-item-edit">Edit</ion-button>
  </ion-card-content>
</ion-card>
